import React from 'react';
import { SidebarVacancyItem } from './SidebarVacancyItem';
import { useVacancyStore } from '../../store/vacancyStore';

interface SidebarVacancyListProps {
  isLoading?: boolean;
}

export function SidebarVacancyList({ isLoading = false }: SidebarVacancyListProps) {
  const { vacancies } = useVacancyStore();

  // Показываем "Загрузка..." только если список пустой и идет загрузка
  if (isLoading && (!vacancies || vacancies.length === 0)) {
    return (
      <div data-testid="sidebar-vacancy-list-loading" className="flex-1 overflow-y-auto">
        <div className="px-5 py-4 text-center text-[var(--text-tertiary)] text-[14px]">
          Загрузка...
        </div>
      </div>
    );
  }

  // Если загрузка закончилась и список пустой
  if (!isLoading && (!vacancies || vacancies.length === 0)) {
    return (
      <div data-testid="sidebar-vacancy-list-empty" className="flex-1 overflow-y-auto">
        <div className="px-5 py-4 text-center text-[var(--text-tertiary)] text-[14px]">
          Нет вакансий
        </div>
      </div>
    );
  }

  return (
    <div data-testid="sidebar-vacancy-list" className="flex-1 overflow-y-auto custom-scrollbar">
      <div data-testid="sidebar-vacancy-list-inner" className="px-5 space-y-0.5">
        {vacancies.map((vacancy) => (
          <SidebarVacancyItem
            key={vacancy.id}
            vacancy={vacancy}
          />
        ))}
      </div>
    </div>
  );
}
